import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { withStorageSync } from './storege-sync.feature';
import { HistoryBook } from '../+models/history-book.model';
import { environment } from '../../../environments/environment';
import { inject } from '@angular/core';
import { HistoryBookService } from 'src/app/history-book/history-book.service';

type HistoryBookState = {
  history: HistoryBook[];
};

const initialState: HistoryBookState = {
  history: [],
};

export const HISTORY_BOOK_STORE = signalStore(
  { providedIn: 'root', protectedState: false },
  withState(initialState),
  withStorageSync({
    key: environment.providers.historyBookstore.toLowerCase(),
  }),
  withMethods((store) => {
    const historyBookService = inject(HistoryBookService);

    return {
      clearStore() {
        patchState(store, initialState);
        store.clearStorage();
      },
      addHistory(entry: HistoryBook) {
        const currentHistory = store.history();
        patchState(store, {
          history: [...currentHistory, entry],
        });

        // Send the history to the server
        historyBookService.sendHistoryBook(entry);
      },
      getHistory(): HistoryBook[] {
        return store.history();
      },
      updateHistory(updatedHistory: HistoryBook[]) {
        patchState(store, { history: updatedHistory });
      },
    };
  })
);
